import { create } from 'zustand';

const webSocketStore = create((set, get) => ({
    uploadStatuses: {},
    wsRef: null,

    connectWebSocket: (wsUrl, uuids = []) => {
        if (get().wsRef) return; // Prevent multiple connections

        const ws = new WebSocket(wsUrl);

        ws.onopen = () => {
            console.log("Connected to WebSocket");
            uuids.forEach((uuid) => {
                ws.send(JSON.stringify({ uuid }));
            });
        };

        ws.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                console.log("WebSocket update:", data);
                set((state) => ({
                    uploadStatuses: {
                        ...state.uploadStatuses,
                        [data.uuid]: {
                            status: data.status,
                            progress: data.percentComplete,
                        },
                    },
                }));
            } catch (err) {
                console.error("Error parsing WebSocket message:", err);
            }
        };

        ws.onclose = () => {
            console.warn("⚠️ WebSocket disconnected. Attempting reconnect...");
            set({ wsRef: null });
            setTimeout(() => get().connectWebSocket(wsUrl, uuids), 500);
        };

        ws.onerror = (err) => {
            console.error("WebSocket error:", err);
            ws.close();
        };

        set({ wsRef: ws });
    },

    disconnectWebSocket: () => {
        const ws = get().wsRef;
        if (ws) {
            ws.close();
            set({ wsRef: null });
            console.log("WebSocket disconnected manually.");
        }
    },
}));

export default webSocketStore;